export default "__VITE_ASSET__98078f53__"